import LocalStorageService from "@ane/core/lib/services/LocalStorageService";
import { VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTIN, VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTOUT, PREVIEW_SCORECARD_USER_OPTED_IN_INITIAL_STAGE, PREVIEW_SCORECARD_USER_OPTED_OUT_INTERMEDIATE_STAGE } from "@ane/core/lib/constants/LocalStorage.constants";
import { TASService } from "../tas/TASService.js";
import Logger from "@ane/core/lib/services/logging/Logger";
import EnvironmentService, { METRICSAUTHORINGOPTINLEVEL, PREVIEWSCORECARDOPTINLEVEL } from "@ane/core/lib/services/EnvironmentService";
import NavigationService from "@ane/core/lib/services/NavigationService";
import { NEW_PREVIEW_SCORECARD_DRI_BYPASS } from "@ane/core/lib/constants/QueryString.constants";
const isMetricsAuthoringOptInFlagSetToTrue = () => {
  return LocalStorageService.getItem(VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTIN) === true;
};
const isMetricsAuthoringOptOutFlagSetToTrue = () => {
  return LocalStorageService.getItem(VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTOUT) === true;
};
const setMetricsAuthoringOptInFlag = (value) => {
  LocalStorageService.setItem(VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTIN, value);
};
const setMetricsAuthoringOptOutFlag = (value) => {
  LocalStorageService.setItem(VIVACE_REDIRECT_TO_METRICS_AUTHORING_OPTOUT, value);
};
const isAnEGroupMember = () => {
  return !!TASService.isAnEGroupMember() ? TASService.isAnEGroupMember() : false;
};
const isOptInLevelOptIn = () => {
  return EnvironmentService.vivaceiframeoptinlevel() === METRICSAUTHORINGOPTINLEVEL.OptIn;
};
const isOptInLevelOptInWarning = () => {
  return EnvironmentService.vivaceiframeoptinlevel() === METRICSAUTHORINGOPTINLEVEL.OptInWarning;
};
const isOptInLevelOptOut = () => {
  return EnvironmentService.vivaceiframeoptinlevel() === METRICSAUTHORINGOPTINLEVEL.OptOut;
};
const isOptInLevelDisableOptOut = () => {
  return EnvironmentService.vivaceiframeoptinlevel() === METRICSAUTHORINGOPTINLEVEL.DisableOptOut;
};
const isOptInLevelNew = () => {
  return EnvironmentService.vivaceiframeoptinlevel() === METRICSAUTHORINGOPTINLEVEL.New;
};
const logUserOptIn = (useOptInLink) => {
  const user = EnvironmentService.getUser();
  const optInLevel = EnvironmentService.vivaceiframeoptinlevel();
  Logger.trackMetric({
    name: "Vivace_Redirect_Opt_In",
    average: 1,
    properties: {
      User_OID: user.oid || "oidundefined",
      Url: document.location.href || "urlundefined",
      optInLevel,
      redirectToOptInLink: useOptInLink,
      isMetricsAuthoringOptInFlagSetToTrue: isMetricsAuthoringOptInFlagSetToTrue(),
      isMetricsAuthoringOptOutFlagSetToTrue: isMetricsAuthoringOptOutFlagSetToTrue(),
      isAneTeamOnly: isAnEGroupMember()
    }
  });
};
const redirectToExpUXRoute = () => {
  let result;
  if (isOptInLevelOptIn() || isOptInLevelOptInWarning()) {
    result = isMetricsAuthoringOptInFlagSetToTrue();
  } else if (isOptInLevelOptOut()) {
    result = !isMetricsAuthoringOptOutFlagSetToTrue();
  } else if (isOptInLevelDisableOptOut() || isOptInLevelNew()) {
    result = true;
  } else
    result = false;
  logUserOptIn(result);
  return result;
};
const isPreviewScorecardOptIn = () => {
  return EnvironmentService.enableNewPreviewScorecardPage() && EnvironmentService.previewScorecardOptinLevel() === PREVIEWSCORECARDOPTINLEVEL.OptIn;
};
const isPreviewScorecardOptOut = () => {
  return EnvironmentService.enableNewPreviewScorecardPage() && EnvironmentService.previewScorecardOptinLevel() === PREVIEWSCORECARDOPTINLEVEL.OptOut;
};
const isPreviewScorecardDisableOptOut = () => {
  return EnvironmentService.enableNewPreviewScorecardPage() && EnvironmentService.previewScorecardOptinLevel() === PREVIEWSCORECARDOPTINLEVEL.DisableOptOut;
};
const showNewPreviewScorecardExperience = () => {
  if (NavigationService.getQueryParamValue(NEW_PREVIEW_SCORECARD_DRI_BYPASS) === "true") {
    return false;
  } else if (isPreviewScorecardOptIn()) {
    return !!LocalStorageService.getItem(PREVIEW_SCORECARD_USER_OPTED_IN_INITIAL_STAGE);
  } else if (isPreviewScorecardOptOut()) {
    return !LocalStorageService.getItem(PREVIEW_SCORECARD_USER_OPTED_OUT_INTERMEDIATE_STAGE);
  } else if (isPreviewScorecardDisableOptOut()) {
    return true;
  }
  return false;
};
const optInToNewPreviewScorecardExperience = () => {
  if (isPreviewScorecardOptIn()) {
    LocalStorageService.setItem(PREVIEW_SCORECARD_USER_OPTED_IN_INITIAL_STAGE, true);
  } else if (isPreviewScorecardOptOut()) {
    LocalStorageService.setItem(PREVIEW_SCORECARD_USER_OPTED_OUT_INTERMEDIATE_STAGE, false);
  }
};
const optOutFromNewPreviewScorecardExperience = () => {
  if (isPreviewScorecardOptIn()) {
    LocalStorageService.setItem(PREVIEW_SCORECARD_USER_OPTED_IN_INITIAL_STAGE, false);
  } else if (isPreviewScorecardOptOut()) {
    LocalStorageService.setItem(PREVIEW_SCORECARD_USER_OPTED_OUT_INTERMEDIATE_STAGE, true);
  }
};
export {
  isAnEGroupMember,
  isMetricsAuthoringOptInFlagSetToTrue,
  isMetricsAuthoringOptOutFlagSetToTrue,
  isOptInLevelDisableOptOut,
  isOptInLevelNew,
  isOptInLevelOptIn,
  isOptInLevelOptInWarning,
  isOptInLevelOptOut,
  isPreviewScorecardDisableOptOut,
  isPreviewScorecardOptIn,
  isPreviewScorecardOptOut,
  optInToNewPreviewScorecardExperience,
  optOutFromNewPreviewScorecardExperience,
  redirectToExpUXRoute,
  setMetricsAuthoringOptInFlag,
  setMetricsAuthoringOptOutFlag,
  showNewPreviewScorecardExperience
};
//# sourceMappingURL=VivaceOptIn.utils.js.map
